// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400&family=Roboto:wght@300;400;500;700;900&family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* input fiiled */
.my_post {
    width: 100%;
    height: 5rem;
    background: #492E87;
    color: white;
    border-radius: 7px;
    border: 1px dotted white;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
    
}

.my_post img {
   height: 55px;
   width: 55px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%
}

.my_post .post_top {
    /* display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap:5px */
}



 
.my_post  p{
    font-size: 2rem;
    font-weight: 600;
    font-family: 'Poppins', sans-serif;
    color: black;
    border-radius: 20px;
    /* background-color: yellow; */
}

/* create post modal */
.create_post_modal_mainDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    position: absolute  ;
    top:10%;

    min-height: 90vh;
    background-color: #111;
}

.create_post_modal_container {
    width: 560px;
    height: 460px;
    overflow: hidden;
    background: #fff;
    border-radius: 10px;
    transition: height 0.2s ease;
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);
}

.create_post_modal_container .create_post_modal_containr_wrapper {
    width: 100wh;
    display: flex;
}

.create_post_modal_container .create_post_modal_container_wrapper section {
    width: 100%;
    background: #fff;
}

.create_post_modal_container img {
    cursor: pointer;
}

.create_post_modal_container .create_post_modal_post {
    transition: margin-left 0.18s ease;
}

.create_post_modal_container.active .create_post_modal_post {
    margin-left: -500px;
}

.create_post_modal_post header {
    font-size: 22px;
    font-weight: 600;
    padding: 12px 0;
    text-align: center;
    border-bottom: 1px solid #bfbfbf;

}

.create_post_modal_post form {
    margin: 20px 25px;
}

.create_post_modal_post form .create_post_modal_content,
.audience .create_post_modal_list li .column {
    display: flex;
    align-items: center;
}

.create_post_modal_post form .create_post_modal_content img {
    cursor: default;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: contain;
}

.create_post_modal_post form .create_post_modal_content .create_post_modal_details {
    margin: -3px 0 0 4px;
}

form .create_post_modal_content .create_post_modal_details p {
    font-size: 17px;
    font-weight: 500;
    padding: 0;
    margin: 0;
}

form :where(textarea, button) {
    width: 100%;
    outline: none;
    border: none;
}

form textarea {
    resize: none;
    font-size: 18px;
    margin-top: 30px;
    min-height: 70px;
}

form textarea::placeholder {
    color: #858585;
}

form textarea:focus::placeholder {
    color: #b3b3b3;
}

.create_post_modal_media_inpit {
    width: 100%;
    height: 60px;
    border: 1px solid #2196f3;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
}

form .create_post_modal_options :where(.create_post_modal_list, li),
.audience :where(.arrow-back, .icon, li .radio) {
    display: flex;
    align-items: center;
    justify-content: center;
}

form .create_post_modal_options p {
    color: #595959;
    font-size: 15px;
    font-weight: 500;
    cursor: default;
}

form .create_post_modal_options .create_post_modal_list {
    list-style: none;
}

.create_post_modal_options .create_post_modal_list li {
    height: 42px;
    width: 42px;
    margin: 0 -1px;
    cursor: pointer;
    border-radius: 50%;
}

.create_post_modal_options .create_post_modal_list li:hover {
    background: #f0f1f4;
}

.create_post_modal_options .create_post_modal_list li img {
    width: 23px;
}

form button {
    height: 53px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
    color: #BCC0C4;
    cursor: no-drop;
    border-radius: 7px;
    background: #e2e5e9;
    transition: all 0.3s ease;
}

form textarea:valid~button {
    color: #fff;
    cursor: pointer;
    background: #4599FF;
}

form textarea:valid~button:hover {
    background: #1a81ff;
}

.image-container {
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
}

.image-container embed {
    width: 100%;
    height: auto;
}

@media screen and (max-width: 480px) {
    .my_post  p{
        font-size: 1rem;
        margin-left: 2rem;
    }
    .my_post img {
        height: 40px;
        width: 40px;
         
     }
}`, "",{"version":3,"sources":["webpack://./src/components/PostSection/CreatePost/CreatePost.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,wBAAwB;IACxB,wCAAwC;;AAE5C;;AAEA;GACG,YAAY;GACZ,WAAW;IACV,iBAAiB;IACjB,uBAAuB;IACvB;AACJ;;AAEA;IACI;;;aAGS;AACb;;;;;AAMA;IACI,eAAe;IACf,gBAAgB;IAChB,kCAAkC;IAClC,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,OAAO;;IAEP,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gCAAgC;;AAEpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,YAAY;QACZ,WAAW;;KAEd;AACL","sourcesContent":["/* input fiiled */\r\n.my_post {\r\n    width: 100%;\r\n    height: 5rem;\r\n    background: #492E87;\r\n    color: white;\r\n    border-radius: 7px;\r\n    border: 1px dotted white;\r\n    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);\r\n    \r\n}\r\n\r\n.my_post img {\r\n   height: 55px;\r\n   width: 55px;\r\n    object-fit: cover;\r\n    object-position: center;\r\n    border-radius: 50%\r\n}\r\n\r\n.my_post .post_top {\r\n    /* display: flex;\r\n    align-items: center;\r\n    justify-content: space-evenly;\r\n    gap:5px */\r\n}\r\n  @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400&family=Roboto:wght@300;400;500;700;900&family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n\r\n\r\n\r\n \r\n.my_post  p{\r\n    font-size: 2rem;\r\n    font-weight: 600;\r\n    font-family: 'Poppins', sans-serif;\r\n    color: black;\r\n    border-radius: 20px;\r\n    /* background-color: yellow; */\r\n}\r\n\r\n/* create post modal */\r\n.create_post_modal_mainDiv {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    position: absolute  ;\r\n    top:10%;\r\n\r\n    min-height: 90vh;\r\n    background-color: #111;\r\n}\r\n\r\n.create_post_modal_container {\r\n    width: 560px;\r\n    height: 460px;\r\n    overflow: hidden;\r\n    background: #fff;\r\n    border-radius: 10px;\r\n    transition: height 0.2s ease;\r\n    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.create_post_modal_container .create_post_modal_containr_wrapper {\r\n    width: 100wh;\r\n    display: flex;\r\n}\r\n\r\n.create_post_modal_container .create_post_modal_container_wrapper section {\r\n    width: 100%;\r\n    background: #fff;\r\n}\r\n\r\n.create_post_modal_container img {\r\n    cursor: pointer;\r\n}\r\n\r\n.create_post_modal_container .create_post_modal_post {\r\n    transition: margin-left 0.18s ease;\r\n}\r\n\r\n.create_post_modal_container.active .create_post_modal_post {\r\n    margin-left: -500px;\r\n}\r\n\r\n.create_post_modal_post header {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    padding: 12px 0;\r\n    text-align: center;\r\n    border-bottom: 1px solid #bfbfbf;\r\n\r\n}\r\n\r\n.create_post_modal_post form {\r\n    margin: 20px 25px;\r\n}\r\n\r\n.create_post_modal_post form .create_post_modal_content,\r\n.audience .create_post_modal_list li .column {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.create_post_modal_post form .create_post_modal_content img {\r\n    cursor: default;\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    object-fit: contain;\r\n}\r\n\r\n.create_post_modal_post form .create_post_modal_content .create_post_modal_details {\r\n    margin: -3px 0 0 4px;\r\n}\r\n\r\nform .create_post_modal_content .create_post_modal_details p {\r\n    font-size: 17px;\r\n    font-weight: 500;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\nform :where(textarea, button) {\r\n    width: 100%;\r\n    outline: none;\r\n    border: none;\r\n}\r\n\r\nform textarea {\r\n    resize: none;\r\n    font-size: 18px;\r\n    margin-top: 30px;\r\n    min-height: 70px;\r\n}\r\n\r\nform textarea::placeholder {\r\n    color: #858585;\r\n}\r\n\r\nform textarea:focus::placeholder {\r\n    color: #b3b3b3;\r\n}\r\n\r\n.create_post_modal_media_inpit {\r\n    width: 100%;\r\n    height: 60px;\r\n    border: 1px solid #2196f3;\r\n    border-radius: 6px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin: 1rem 0;\r\n}\r\n\r\nform .create_post_modal_options :where(.create_post_modal_list, li),\r\n.audience :where(.arrow-back, .icon, li .radio) {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\nform .create_post_modal_options p {\r\n    color: #595959;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    cursor: default;\r\n}\r\n\r\nform .create_post_modal_options .create_post_modal_list {\r\n    list-style: none;\r\n}\r\n\r\n.create_post_modal_options .create_post_modal_list li {\r\n    height: 42px;\r\n    width: 42px;\r\n    margin: 0 -1px;\r\n    cursor: pointer;\r\n    border-radius: 50%;\r\n}\r\n\r\n.create_post_modal_options .create_post_modal_list li:hover {\r\n    background: #f0f1f4;\r\n}\r\n\r\n.create_post_modal_options .create_post_modal_list li img {\r\n    width: 23px;\r\n}\r\n\r\nform button {\r\n    height: 53px;\r\n    color: #fff;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    cursor: pointer;\r\n    color: #BCC0C4;\r\n    cursor: no-drop;\r\n    border-radius: 7px;\r\n    background: #e2e5e9;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\nform textarea:valid~button {\r\n    color: #fff;\r\n    cursor: pointer;\r\n    background: #4599FF;\r\n}\r\n\r\nform textarea:valid~button:hover {\r\n    background: #1a81ff;\r\n}\r\n\r\n.image-container {\r\n    width: 100%;\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n}\r\n\r\n.image-container embed {\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n@media screen and (max-width: 480px) {\r\n    .my_post  p{\r\n        font-size: 1rem;\r\n        margin-left: 2rem;\r\n    }\r\n    .my_post img {\r\n        height: 40px;\r\n        width: 40px;\r\n         \r\n     }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
